import {WorkrequestCmpDetails} from './workrequest-cmp-details';

export class FireCmpViewmodel {
  workrequestDetails: WorkrequestCmpDetails;
  private _fireServiceYes: boolean;
  private _fireServiceNo: boolean;
  private _boosterYes: boolean;
  private _boosterNo: boolean;
  private _hydrantYes: boolean;
  private _hydrantNo: boolean;
  private _sprinklerYes: boolean;
  private _sprinklerNo: boolean;
  private _hoseReelYes: boolean;
  private _hoseReelNo: boolean;
  private _pumpYes: boolean;
  private _pumpNo: boolean;
  private _tankYes: boolean;
  private _tankNo: boolean;


  get fireServiceYes(): boolean {
    return this._fireServiceYes;
  }

  set fireServiceYes(v: boolean) {
    this._fireServiceYes = v;
    this.workrequestDetails.fire = v;
    if (v) {
      this._fireServiceNo = false;
    }
  }

  get fireServiceNo(): boolean {
    return this._fireServiceNo;
  }

  set fireServiceNo(v: boolean) {
    this._fireServiceNo = v;
    this.workrequestDetails.fire = !v;
    if (v) {
      this._fireServiceYes = false;
    }
  }

  get fireServiceSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSelected;
  }

  set fireServiceSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSize =
        (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceFlow =
          (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceQty = null;
    }
  }

  get fireServiceSize(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSize;
  }

  set fireServiceSize(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSize = v;
    if (v > 0) {
      this.fireServiceSelected = true;
    }
  }

  get fireServiceFlow(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceFlow;
  }

  set fireServiceFlow(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceFlow = v;
    if (v > 0) {
      this.fireServiceSelected = true;
    }
  }

  get fireServiceQty(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceQty;
  }

  set fireServiceQty(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceQty = v;
    if (v > 0) {
      this.fireServiceSelected = true;
    }
  }

  get boosterYes(): boolean {
    return this._boosterYes;
  }

  set boosterYes(v: boolean) {
    this._boosterYes = v;
    this.workrequestDetails.booster = v;
    if (v) {
      this._boosterNo = false;
    }
  }

  get boosterNo(): boolean {
    return this._boosterNo;
  }

  set boosterNo(v: boolean) {
    this._boosterNo = v;
    this.workrequestDetails.booster = !v;
    if (v) {
      this._boosterYes = false;
    }
  }

  get hydrantYes(): boolean {
    return this._hydrantYes;
  }

  set hydrantYes(v: boolean) {
    this._hydrantYes = v;
    this.workrequestDetails.hydrant = v;
    if (v) {
      this._hydrantNo = false;
    }
  }

  get hydrantNo(): boolean {
    return this._hydrantNo;
  }

  set hydrantNo(v: boolean) {
    this._hydrantNo = v;
    this.workrequestDetails.hydrant = !v;
    if (v) {
      this._hydrantYes = false;
    }
  }

  get sprinklerYes(): boolean {
    return this._sprinklerYes;
  }

  set sprinklerYes(v: boolean) {
    this._sprinklerYes = v;
    this.workrequestDetails.sprinkler = v;
    if (v) {
      this._sprinklerNo = false;
    }
  }

  get sprinklerNo(): boolean {
    return this._sprinklerNo;
  }

  set sprinklerNo(v: boolean) {
    this._sprinklerNo = v;
    this.workrequestDetails.sprinkler = !v;
    if (v) {
      this._sprinklerYes = false;
    }
  }

  get hoseReelYes(): boolean {
    return this._hoseReelYes;
  }

  set hoseReelYes(v: boolean) {
    this._hoseReelYes = v;
    this.workrequestDetails.hoseReel = v;

    if (v) {
      this._hoseReelNo = false;
    }
  }

  get hoseReelNo(): boolean {
    return this._hoseReelNo;
  }

  set hoseReelNo(v: boolean) {
    this._hoseReelNo = v;
    this.workrequestDetails.hoseReel = !v;
    if (v) {
      this._hoseReelYes = false;
    }
  }

  get pumpYes(): boolean {
    return this._pumpYes;
  }

  set pumpYes(v: boolean) {
    this._pumpYes = v;
    this.workrequestDetails.pump = v;
    if (v) {
      this._pumpNo = false;
    }
  }

  get pumpNo(): boolean {
    return this._pumpNo;
  }

  set pumpNo(v: boolean) {
    this._pumpNo = v;
    this.workrequestDetails.pump = !v;
    if (v) {
      this._pumpYes = false;
    }
  }

  get tankYes(): boolean {
    return this._tankYes;
  }

  set tankYes(v: boolean) {
    this._tankYes = v;
    this.workrequestDetails.tank = v;
    if (v) {
      this._tankNo = false;
    }
  }

  get tankNo(): boolean {
    return this._tankNo;
  }

  set tankNo(v: boolean) {
    this._tankNo = v;
    this.workrequestDetails.tank = !v;
    if (v) {
      this._tankYes = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/cmp-form/fire-cmp-viewmodel.ts